import React from 'react'
import "./home.css";
export default function About(){

return(<>
<div id="about" data-aos="fade-up">
        <div class="mydetails">
        <h1 style={{fontSize:"50px",textAlign:"left"}}>Introduction</h1>
        <ul style={{color:"#f7f7f7",textAlign: "start",marginBottom:"0"}}>
            <li><p >I am a Front-end developer and a CSE undergraduate from   MMMUT. I am very passionate about improving my coding skills & developing websites. I build Websites using Front-end Technologies. Working for myself to improve my skills. Love to build and explore.</p></li><br/>
                <li style={{color:"#78d0eb"}}>Email: raghvendra1482002@gmail.com</li>
        </ul>
        </div>
    </div>
</>)

}